import React from "react";
import "../main.css";
import midecodes from "../Assets/midecodes.jpg";

const About = () => {
  return (
    <div id="About">
      <section class="section about">
        <div class="section-center about-center">
          <article class="about-img">
            <img src={midecodes} class="hero-photo" alt="about img" />
          </article>

          <article class="about-info">
            <div class="section-title about-title">
              <h2>about</h2>
              <div class="underline" />
            </div>

            <p>I'm <strong> Olomitutu Olufemi Sunday,</strong>
            Passionate Frontend Developer adept in all stages of advanced web
            development. Knowledgeable in user interface, testing, and debugging
            processes. Equipped with a diverse and promising skill-set.
            Proficient in an assortment of technologies, including HTML, CSS,
            JavaScript, React, Bootstrap, Git & GitHub, Pivotal Tracker, Trello.
            
          </p>
          <p>
            Able to effectively selfmanage during independent projects, as well
            as collaborate in a team setting. Ability to work remotely and
            onsite. Great Team player and Team Lead as the case may be.
          </p>
          </article>
        </div>
      </section>
    </div>
  );
};

export default About;
